import React from 'react';
import { Link } from '@uhg-abyss/web/ui/Link';
import PropTypes from 'prop-types';
import { useRouter } from '@uhg-abyss/web/hooks/useRouter';

export const StyledMarkdownLink = ({ children, href }) => {
  const { navigate } = useRouter();
  const routeUrl = (url) => {
    navigate(url);
  };

  return (
    <Link
      id="custom-link"
      fontWeight="bold"
      href={href}
      onClick={(e) => {
        e.preventDefault();
        routeUrl(href);
      }}
    >
      {children}
    </Link>
  );
};

StyledMarkdownLink.propTypes = {
  children: PropTypes.node.isRequired,
  href: PropTypes.string.isRequired,
};
